import { useCircleV4 } from "@/react/hooks/useCircleV4";

// The admin/Settings AppShell ships with the Circle 4.0 UI, so it shares the
// member-area AppShell condition (the active v4 UI).
export const useIsAppShellAdminAreaEnabled = () => useCircleV4().isCircleV4;
